// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DealerSearchModal from './dealer-search-modal';
import {FormattedMessage} from 'react-intl';
import Modal from '../../shared/state/modal';
import {stripSpaces} from '../../../shared/services/strip-spaces';

function handleChange(event) {

    const processedValue = stripSpaces(event.target.value);

    this.onAccountLookupChange(processedValue);

}

function handleKeyPress(event) {

    if (event.key === 'Enter' || event.key === 'Tab') {

        const processedValue = stripSpaces(event.target.value);

        this.onAccountLookupBlur(processedValue);

    }

}

function handleFocus(event) {

    if (event.target.value) {

        event.target.select();

    }

}

const DealerSearchLink = props =>
    <div className='dealer-search-link'>
        {
            props.account ?
                <span
                    className='icon-search'
                    onClick={props.onResetClick}
                /> :
                    (<div className='dealer-search-controls'>
                        <input
                            autoFocus={true}
                            className='dealer-search-input'
                            onChange={props::handleChange}
                            onFocus={handleFocus}
                            onKeyDown={props::handleKeyPress}
                            type='text'
                            value={props.accountLookup}
                        />
                        <span className='dealer-search-or'><FormattedMessage id='OR'/></span>
                        <button
                            className='dealer-search-button'
                            onClick={props.onDealerSearchViewClick}
                        >
                            <span className='icon-search-small'/>
                            <FormattedMessage id='DEALER_SEARCH'/>
                        </button>
                    </div>)
        }
        <DealerSearchModal
            isOpen={props.dealerSearchModal.isVisible}
            onClose={props.onDealerSearchViewClick}
        />
    </div>;

DealerSearchLink.displayName = 'DealerSearchLink';
DealerSearchLink.propTypes = {
    account: PropTypes.string.isRequired,
    accountLookup: PropTypes.string.isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal).isRequired,
    onAccountLookupBlur: PropTypes.func.isRequired,
    onAccountLookupChange: PropTypes.func.isRequired,
    onDealerSearchViewClick: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired
};

export default DealerSearchLink;




// WEBPACK FOOTER //
// ./src/product/new-transfer/components/dealer-search-link.js